import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Settings, LogOut } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import AdminProfileContent from "./AdminProfileContent";
import "./AdminHeader.css";

const AdminHeader = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const adminBasePath = "/components/Admins/AdminLayout";

  const [menuOpen, setMenuOpen] = useState(false);
  const [profileModalOpen, setProfileModalOpen] = useState(false);
  const [isAnnouncementVisible, setIsAnnouncementVisible] = useState(true);

  useEffect(() => {
    const topOffset = isAnnouncementVisible ? "124px" : "74px";
    document.documentElement.style.setProperty(
      "--admin-layout-top-offset",
      topOffset,
    );

    return () => {
      document.documentElement.style.removeProperty("--admin-layout-top-offset");
    };
  }, [isAnnouncementVisible]);

  const handleNavigate = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  const handleProfileModalOpen = () => {
    setMenuOpen(false);
    setProfileModalOpen(true);
  };

  const handleProfileModalClose = () => {
    setProfileModalOpen(false);
  };

  return (
    <div className="admin-header-shell">
      <div
        className={`admin-top-announcement ${isAnnouncementVisible ? "visible" : "hidden"}`}
      >
        <div className="admin-top-announcement-content">
          <div className="admin-top-announcement-text">
            <span>Read CEO&apos;s </span>
            <Link
              to="/letter-to-shareholders"
              state={{ hidePublicNavbar: true, fromAdmin: true }}
              className="admin-top-announcement-link"
            >
              Letter to Shareholders
            </Link>
          </div>

          <button
            type="button"
            className="admin-top-announcement-close"
            onClick={() => setIsAnnouncementVisible(false)}
            aria-label="Close announcement"
          >
            &times;
          </button>
        </div>
      </div>

      <div className="admin-top-strip" />

      <header className="admin-global-header">

        {/* LEFT SIDE */}
        <div className="admin-header-left">

          <div className="admin-grid-wrapper">
            <button
              className="admin-grid-icon"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              {Array.from({ length: 9 }).map((_, i) => (
                <span key={i} className="admin-dot" />
              ))}
            </button>

            {menuOpen && (
              <div className="admin-grid-dropdown">
                <div
                  className="admin-dropdown-item"
                  onClick={() => handleNavigate(adminBasePath)}
                >
                  HOME PAGE
                </div>

                <div
                  className="admin-dropdown-item"
                  onClick={() => handleNavigate(`${adminBasePath}/dashboard`)}
                >
                  Admin Users
                </div>

                <div
                  className="admin-dropdown-item"
                  onClick={() => handleNavigate(`${adminBasePath}/role-management`)}
                >
                  Role Management
                </div>

                <div
                  className="admin-dropdown-item"
                  onClick={() => handleNavigate(`${adminBasePath}/blog-management`)}
                >
                  Blog Management
                </div>

                <div
                  className="admin-dropdown-item"
                  onClick={() => handleNavigate(`${adminBasePath}/job-management`)}
                >
                  Job Management
                </div>

                <div
                  className="admin-dropdown-item"
                  onClick={() =>
                    handleNavigate(`${adminBasePath}/shareholder-letters`)
                  }
                >
                  Shareholder Letters
                </div>

                <div
                  className="admin-dropdown-item"
                  onClick={() =>
                    handleNavigate(`${adminBasePath}/application-management`)
                  }
                >
                  Application Management
                </div>

                <div
                  className="admin-dropdown-item"
                  onClick={() =>
                    handleNavigate(`${adminBasePath}/interview-scheduling`)
                  }
                >
                  Interview Scheduling
                </div>

                <div
                  className="admin-dropdown-item"
                  onClick={() => handleNavigate(`${adminBasePath}/exporting-data`)}
                >
                  Exporting Data
                </div>

                <div
                  className="admin-dropdown-item"
                  onClick={() => handleNavigate(`${adminBasePath}/our-clients`)}
                >
                  Our Clients
                </div>
              </div>
            )}
          </div>

            <span className="BlackRoth-admin" >BlackRoth<span className="trademark-admin">TM</span> </span>

          

        </div>

        {/* RIGHT SIDE */}
        <div className="admin-header-right">

          {/* PROFILE BUTTON */}
          <button
            type="button"
            className="admin-panel-badge"
            onClick={handleProfileModalOpen}
            aria-label="Open profile popup"
          >
            <img
              src="/assets/super-admin-icon.svg"
              alt="Super Admin"
              className="admin-panel-avatar"
            />

            <span className="admin-panel-title" >Super Admin</span>

          </button>

          {/* <button className="admin-icon-btn">
            <Search size={18} />
          </button> */}

          <button className="admin-icon-btn">
            <Settings size={18} />
          </button>

          <button
            onClick={() => {
              logout();
              navigate("/");
            }}
            className="admin-logout-pill"
          >
            <span>Log Out</span>

            <span className="logout-icon-wrap">
              <LogOut size={14} />
            </span>

          </button>

        </div>
      </header>

      {profileModalOpen && (
        <div className="admin-profile-modal-overlay" onClick={handleProfileModalClose}>
          <div
            className="admin-profile-modal"
            role="dialog"
            aria-modal="true"
            aria-label="Admin profile popup"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="admin-profile-modal-head">
              <h3>Profile Details</h3>
              <button
                type="button"
                className="admin-profile-modal-close"
                onClick={handleProfileModalClose}
                aria-label="Close profile popup"
              >
                x
              </button>
            </div>

            <div className="admin-profile-modal-content">
              <AdminProfileContent embedded />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminHeader;
